import { OpenedChannel } from '@wix/communication-channel';
import { ProviderAPI, OnBeforeUnload } from '../types';

export const registerBeforeUnloadHandler = (
  channel: OpenedChannel<ProviderAPI>,
) => {
  const eventTarget = new EventTarget();
  const isInWorker = typeof window === 'undefined';

  const onIframeBeforeUnload = (event: BeforeUnloadEvent) => {
    const shouldUnloadWithoutConfirmation = eventTarget.dispatchEvent(
      new CustomEvent('beforeunload', {
        cancelable: true,
      }),
    );

    if (!shouldUnloadWithoutConfirmation) {
      event.preventDefault();
      event.returnValue = true; // Chrome requires returnValue to be set
    }
  };

  const onBeforeUnloadHandle = channel.onBeforeUnload(onIframeBeforeUnload);

  const clearBeforeUnloadHandler = () => {
    if (!isInWorker) {
      window.removeEventListener('beforeunload', onIframeBeforeUnload);
    }
    onBeforeUnloadHandle.then(({ remove }) => remove());
  };
  if (!isInWorker) {
    window.addEventListener('beforeunload', onIframeBeforeUnload);
    window.addEventListener('unload', clearBeforeUnloadHandler);
  }

  const onBeforeUnload: OnBeforeUnload = (callback) => {
    eventTarget.addEventListener('beforeunload', callback);

    const remove = () => {
      eventTarget.removeEventListener('beforeunload', callback);
    };

    return { remove };
  };

  return { onBeforeUnload, clearBeforeUnloadHandler };
};
